export enum ExportFormat {
  A3NOM_SUPPLEMENTS = 'a3nom_supplements',
  A3NOM_EMPLOYEES = 'a3nom_employees',
  BASIC = 'basic',
  PAYSLIP_CONTRACT_CHANGES = 'payslip_contract_changes',
  SUPPLEMENTS = 'supplements',
  EXTENDED = 'extended',
  DATEV_EMPLOYEES = 'datev_employees',
  DELTA = 'delta',
  CONTRACT_CHANGES = 'contract_changes',
  PAIERH_LEAVES = 'paierh_leaves',
  PAIERH_UPDATED_EMPLOYEES = 'paierh_updated_employees',
  PAIERH_SUPPLEMENTS = 'paierh_supplements',
  YEAP_PAIERH_LEAVES = 'yeap_paierh_leaves',
  YEAP_PAIERH_UPDATED_EMPLOYEES = 'yeap_paierh_updated_employees',
  YEAP_PAIERH_SUPPLEMENTS = 'yeap_paierh_supplements',
  SILAE_LEAVES = 'silae_leaves',
  SILAE_LEAVE_DELTAS = 'silae_leave_deltas',
  SILAE_SUPPLEMENTS = 'silae_supplements',
  ZUCCHETTI_LEAVES = 'zucchetti_leaves',
  ZUCCHETTI_TIME = 'zucchetti_time',
  TIMEOFF = 'absences',
  EVENTS_NEW_HIRES = 'events_new_hires',
  EVENTS_PERSONAL_CHANGES = 'events_personal_changes',
  EVENTS_TERMINATIONS = 'events_terminations',
  GISPAGHE_TIME = 'gispaghe_time',
}

export const EVENT_TYPES: ReadonlySet<ExportFormat> = new Set([
  ExportFormat.EVENTS_NEW_HIRES,
  ExportFormat.EVENTS_PERSONAL_CHANGES,
  ExportFormat.EVENTS_TERMINATIONS,
])

export const eventsToExportTypeMap = (type: ExportFormat) => {
  switch (type) {
    case ExportFormat.EVENTS_NEW_HIRES:
      return 'new-hires'
    case ExportFormat.EVENTS_PERSONAL_CHANGES:
      return 'personal-changes'
    case ExportFormat.EVENTS_TERMINATIONS:
      return 'terminations'
    default:
      return null
  }
}

export function isPayrollExportFormat(format: string): format is ExportFormat {
  return Object.values(ExportFormat).some((payrollFormat) => payrollFormat === format)
}

export const NEED_UPDATE_FORMATS: ReadonlySet<ExportFormat> = new Set([
  ExportFormat.BASIC,
  ExportFormat.EXTENDED,
])

// This selector is required by all the exports defined below
export const NEED_EVENTS_STATUS: ReadonlySet<ExportFormat> = new Set([
  ExportFormat.EVENTS_NEW_HIRES,
  ExportFormat.EVENTS_PERSONAL_CHANGES,
  ExportFormat.EVENTS_TERMINATIONS,
])

export const NEED_DATE_FORMATS: ReadonlySet<ExportFormat> = new Set([
  ExportFormat.PAIERH_UPDATED_EMPLOYEES,
  ExportFormat.YEAP_PAIERH_UPDATED_EMPLOYEES,
  ExportFormat.A3NOM_EMPLOYEES,
  ExportFormat.TIMEOFF,
  ExportFormat.EVENTS_NEW_HIRES,
  ExportFormat.CONTRACT_CHANGES,
  ExportFormat.SILAE_LEAVES,
  ExportFormat.EVENTS_PERSONAL_CHANGES,
  ExportFormat.EVENTS_TERMINATIONS,
])

export const NEED_ABSENCES_DATA: ReadonlySet<ExportFormat> = new Set([ExportFormat.TIMEOFF])

export const NO_MAX_DATE_DIFF_FORMATS: ReadonlySet<ExportFormat> = new Set([
  ExportFormat.PAIERH_UPDATED_EMPLOYEES,
  ExportFormat.YEAP_PAIERH_UPDATED_EMPLOYEES,
  ExportFormat.TIMEOFF,
  ExportFormat.EVENTS_NEW_HIRES,
  ExportFormat.SILAE_LEAVES,
  ExportFormat.DELTA,
  ExportFormat.SILAE_LEAVE_DELTAS,
  ExportFormat.EVENTS_PERSONAL_CHANGES,
  ExportFormat.EVENTS_TERMINATIONS,
  ExportFormat.CONTRACT_CHANGES,
])

export enum Integration {
  A3NOM = 'A3Nom',
  BASIC = 'basic',
  EXTENDED = 'extended',
  DATEV = 'Datev',
  DELTA = 'delta',
  PAIERH = 'PaieRH',
  YEAP_PAIERH = 'yeap_paierh',
  SILAE = 'Silae',
  ZUCCHETTI = 'Zucchetti',
}

export const DELTA_FORMATS: ReadonlySet<ExportFormat> = new Set([
  ExportFormat.DELTA,
  ExportFormat.SILAE_LEAVE_DELTAS,
])
